import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from '../components/footer/footer.component';
import { RouterModule } from '@angular/router';
import { CoreModule } from 'src/app/core/core.module';
import { MoreInfoComponent } from './components/more-info/more-info.component';
import { PromoComponent } from './components/promo/promo.component';
import { OnNavbarComponent } from './components/on-navbar/on-navbar.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CoreModule
  ],
  exports: [
    NavbarComponent,
    FooterComponent,
    MoreInfoComponent,
    PromoComponent,
    OnNavbarComponent
  ],
  declarations: [
    NavbarComponent,
    FooterComponent,
    MoreInfoComponent,
    PromoComponent,
    OnNavbarComponent
  ]
})
export class WebModule { }
